import React from 'react';
import { HStack, Spinner, Text, VStack } from '@chakra-ui/react';

const FilterLoader = ({ ...props }) => {
    return (
        <VStack py={'71px'} bg={'semantic.200'} borderRadius={'8px'} {...props} data-testid="filterLoader">
            <HStack>
                <Spinner speed="1s" color="sagitarius.500" />
                <Text>Loading</Text>
            </HStack>
            <Text fontWeight={400} fontSize={'12px'} color={'neutral.700'}>
                Sedang menyiapkan filter untuk pengalaman terbaik ...
            </Text>
        </VStack>
    );
};

export default FilterLoader;
